APP_CONTAINER_VERSION = '12.39.98';
APP_CORE_VERSION = '12.42.71';
APP_CONTAINER_NAME = 'self-digital-fe';
APP_CORE_NAME = 'self-digital-core-fe';

'use strict';

var LHinfo = '';
var LHnick = '';
var LHurl = '';

function LHready() {
  if (document.readyState == 'complete') {
    (function () {
      var lh = document.createElement('script');
      lh.type = 'text/javascript';
      lh.async = true;
      lh.src =
        '//server.livehelp.it/widgetjs/76447/4971.js?x=' + 1 * new Date();
      var node = document.getElementsByTagName('script')[0];
      node.parentNode.insertBefore(lh, node);
    })();
  } else {
    setTimeout('LHready()', 150);
  }
}

LHready();
